<template>
    <div class="float-left">

        <b-button
            variant="success"
            v-if="$temAcessoView('ATADIREX-01') && modoCadastro"
            @click="abrirModal()"
            >Adicionar
        </b-button>

        <i
            class="fa fa-pencil-square fa-lg icon-button"
            title="Alterar Ata"
            v-if="$temAcessoView('ATADIREX-02') && !modoCadastro"
            @click.stop="abrirModal()"
        ></i>

        <b-modal
            id="modalCadAtaDirex"
            size="lg"
            v-model="mostrarModal"
            no-close-on-backdrop
        >

            <div slot="modal-title">
                <span class="h5">
                    Ata Direx - <b-badge variant="warning">{{modoTela}}</b-badge>
                </span>
            </div>

            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="cdTipoAta">Tipo Ata</label>
                        <b-form-select
                                id="cdTipoAta"
                                type="text"
                                :options="tipoAta"
                                value-field="key"
                                text-field="label"
                                v-model="ataDirexDto.cdTipoAta"
                            >
                            </b-form-select>
                            <b-form-invalid-feedback>Tipo Ata é obrigatório</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="nuAtaDirex">Ata Direx</label>
                        <b-form-input
                            id="nuAtaDirex"
                            type="text"
                            placeholder="99/9999"
                            v-model="ataDirexDto.nuAtaDirex"
                            v-mask="[
                                        '##/####'
                                    ]"
                            :disabled="!modoCadastro"
                            @input.native="$v.ataDirexDto.nuAtaDirex.$touch()"
                            :state="$v.ataDirexDto.nuAtaDirex.$error ? false : null"
                        ></b-form-input>
                        <b-form-invalid-feedback>Ata Direx é obrigatória</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="dtReuniao">Data Reunião</label>
                        <b-input-group>
                            <date-picker
                                id="dtReuniao"
                                v-model="ataDirexDto.dtReuniao"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                                @input.native="$v.ataDirexDto.dtReuniao.$touch()"
                                :state="$v.ataDirexDto.dtReuniao.$error ? false : null"
                            ></date-picker>
                            <b-form-invalid-feedback>Data da Reunião é obrigatória</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    @click.stop="salvar()"
                    class="ml-1"
                    :disabled="$v.ataDirexDto.$invalid"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
    import AtaDirexServicos from '../AtaDirexServicos'
    import { required, minValue } from 'vuelidate/lib/validators'


    export default {
        props: {
            AtaDirexPai: Object,
            modoCadastro: Boolean
        },

        validations: {
            valor: {
                required,
                minValue: minValue(0.01)
            },

            ataDirexDto: {
                nuAtaDirex: {required},
                dtReuniao: {required}
            }
        },

        data(){
            return {
                modoTela: null,
                mostrarModal: false,
                erros: [],
                tipoAta: [
                    {
                        key: '1',
                        label: 'Ordinária',
                    },
                    {
                        key: '2',
                        label: 'Extraordinária',
                    }
                ],
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                ataDirexDto: {
                    idAtaDirex: 0,
                    nuAtaDirex: null,
                    dtReuniao: null,
                    cdTipoAta: 0,
                    dtCadastro: null,
                    usrLogin: null,
                    nuSituacaoAta: 0,
                }
            }
        },

        methods: {
            limpar(){
                this.ataDirexDto.idAtaDirex= 0
                this.ataDirexDto.nuAtaDirex= null
                this.ataDirexDto.dtReuniao= null
                this.ataDirexDto.cdTipoAta= 1
                this.ataDirexDto.dtCadastro= null
                this.ataDirexDto.usrLogin= null
                this.ataDirexDto.nuSituacaoAta= 0

            },

            Carregar(){
                this.ataDirexDto.idAtaDirex= this.AtaDirexPai.idAtaDirex;
                this.ataDirexDto.nuAtaDirex= this.AtaDirexPai.nuAtaDirex;
                this.ataDirexDto.dtReuniao= this.$moment(this.AtaDirexPai.dtReuniao).format('DD/MM/YYYY');
                this.ataDirexDto.cdTipoAta= this.AtaDirexPai.cdTipoAta;
                this.ataDirexDto.dtCadastro= this.$moment(this.AtaDirexPai.dtCadastro).format('DD/MM/YYYY');
                this.ataDirexDto.usrLogin= this.AtaDirexPai.usrLogin;
                this.ataDirexDto.nuSituacaoAta= this.AtaDirexPai.nuSituacaoAta;
            },

            abrirModal() {
                this.limpar();
                this.mostrarModal = true;
                this.erros=[];

                this.modoTela = 'NOVO';
                if (!this.modoCadastro){
                    this.modoTela = 'EDITAR';
                    this.Carregar();
                }
            },

            fecharModal() {
                this.mostrarModal = false;
            },

            salvar(){
                this.ataDirexDto.dtReuniao= this.$moment(this.ataDirexDto.dtReuniao, 'DD/MM/YYYY').format('YYYY-MM-DD')

                if (this.modoCadastro){
                    this.$store.dispatch('addRequest')
                    AtaDirexServicos.SalvarAtaDirex(this.ataDirexDto)
                    .then(response => {
                        if (response) {
                            if (response.success) {
                                //this.$emit('listarAtas')
                                this.fecharModal()
                                this.irParaDetalhesProcessosAtaDirex(response.data.idAtaDirex)
                            }
                            else{
                                this.erros = response.errors
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    })
                }else{
                    this.ataDirexDto.dtCadastro= this.$moment(this.ataDirexDto.dtCadastro, 'DD/MM/YYYY').format('YYYY-MM-DD')

                    this.$store.dispatch('addRequest')
                        AtaDirexServicos.AtualizarAtaDirex(this.ataDirexDto)
                        .then(response => {
                            if (response) {
                                if (response.success) {
                                    this.$emit('listarAtas')
                                    this.fecharModal()
                                }
                                else{
                                    this.erros = response.errors
                                }
                            }
                            this.$store.dispatch('removeRequest')
                        })
                }
            },
            irParaDetalhesProcessosAtaDirex(idAtaDirex) {
                this.erros = []
                this.$router.push({
                    name: 'AtaDirexDetalhes',
                    params: {
                        idAtaDirex: idAtaDirex,
                        tabindex:1,
                        mostrarModal:true,
                        nuSituacaoAta:1
                    }
                })
            },
        }
    }
</script>
